<template>
  <form class="quick-feature" @submit.prevent="onSubmit">
    <div class="quick-feature__grid">
      <div class="quick-feature__field">
        <label>نام ویژگی</label>
        <input v-model="form.name" type="text" class="form-control" placeholder="نام ویژگی" @input="syncPublicName">
      </div>
      <div class="quick-feature__field">
        <label>نام عمومی</label>
        <input v-model="form.public_name" type="text" class="form-control" placeholder="نام عمومی">
      </div>
      <div class="quick-feature__field">
        <label>نوع</label>
        <select class="form-control custom-select" v-model="form.type" :disabled="isEdit">
          <option v-for="item in featureTypes" :key="item.value" :value="item.value">
            {{ item.text }}
          </option>
        </select>
      </div>
      <div class="quick-feature__field">
        <label>زبان</label>
        <select class="form-control custom-select" v-model="form.language_id">
          <option value="">انتخاب زبان</option>
          <option v-for="language in languages" :key="language.id" :value="language.id">
            {{ language.name }}
          </option>
        </select>
      </div>
      <div class="quick-feature__field">
        <label>ترتیب</label>
        <input v-model="form.order" type="number" min="1" class="form-control" placeholder="ترتیب">
      </div>
    </div>

    <div class="quick-feature__attrs">
      <div class="quick-feature__attrs-head">
        <label>خصوصیات ویژگی</label>
        <button
            v-if="canBatchAdd"
            type="button"
            class="quick-feature__batch"
            @click="showBatch = !showBatch">
          اضافه کردن جمعی
        </button>
      </div>

      <div class="quick-feature__batch-box" v-if="showBatch && canBatchAdd">
        <textarea
            v-model="formAttributeBatching"
            class="form-control"
            rows="3"
            placeholder="هر خط یک مقدار"></textarea>
        <label class="quick-feature__switch">
          <input type="checkbox" v-model="formAttributeBatchingFilterStatus">
          فیلتر
        </label>
        <button type="button" class="quick-feature__batch-submit" @click="submitFeatureAttributeBatching">
          ثبت جمعی
        </button>
      </div>

      <div class="quick-feature__add-row">
        <input
            v-if="form.type !== 'date'"
            v-model="featureAttributeInput"
            type="text"
            class="form-control"
            placeholder="مقدار ویژگی"
            @keydown.enter.prevent="addItem">
        <date-picker
            v-else
            clearable
            auto-submit
            v-model="featureAttributeInput"
            placeholder="انتخاب تاریخ"
            format="YYYY-MM-DD"
            display-format="jYYYY/jM/jD"/>
        <button type="button" class="quick-feature__add-btn" @click="addItem">اضافه کردن</button>
      </div>

      <div class="quick-feature__items">
        <div
            class="quick-feature__item"
            v-for="(item, index) in form.feature_attributes"
            :key="item.id || index">
          <feature-attribute
              :feature="form"
              :feature-index="index"
              :item="item"
              @removeFeatureAttribute="removeItem"/>
        </div>
      </div>

      <p class="quick-feature__hint" v-if="unFilteredFeatureTypes.indexOf(form.type) === -1">
        تیک جلوی ویژگی باعث اضافه شدن آن به فیلترهای آرشیو محصول می‌شود.
      </p>
    </div>

    <div class="quick-feature__actions">
      <button type="submit" class="quick-feature__submit" :disabled="loading">
        {{ loading ? 'در حال ثبت...' : (isEdit ? 'بروزرسانی ویژگی' : 'ثبت ویژگی') }}
      </button>
    </div>
  </form>
</template>

<script>
import {mapGetters} from 'vuex'
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {featureTypes, unFilteredFeatureTypes} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Feature";
import {checkValueIsNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import FeatureAttribute from "@/plugin/components/dashboard/Feature/components/FeatureAttribute.vue";

export default {
  name: "QuickFeatureCreate",
  components: {
    FeatureAttribute,
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    mode: {
      type: String,
      default: 'create'
    },
    featureId: {
      default: null
    }
  },
  data() {
    return {
      loading: false,
      featureTypes,
      unFilteredFeatureTypes,
      featureAttributeInput: '',
      showBatch: false,
      formAttributeBatching: '',
      formAttributeBatchingFilterStatus: false,
      form: {
        id: '',
        name: '',
        public_name: '',
        type: 'text',
        language_id: '',
        order: 1,
        feature_attributes: [],
        featureImage: [],
        featureImagePreview: '',
        noRedirect: true,
      }
    }
  },
  computed: {
    ...mapGetters({
      languages: "Language/getLanguages",
    }),
    isEdit() {
      return this.mode === 'edit'
    },
    canBatchAdd() {
      return ['checkbox-step', 'list-step', 'list', 'list-with-text-value'].indexOf(this.form.type) > -1
    }
  },
  methods: {
    checkValueIsNumber,
    syncPublicName() {
      if (!this.form.public_name || this.form.public_name === this._lastSyncedName) {
        this.form.public_name = this.form.name
        this._lastSyncedName = this.form.name
      }
    },
    addItem() {
      const value = typeof this.featureAttributeInput === 'string'
          ? this.featureAttributeInput.trim()
          : this.featureAttributeInput
      if (!value) {
        return
      }
      if ((this.form.type == 'text' || this.form.type == 'link') && this.form.feature_attributes.length == 1) {
        toast('خطا', 'برای ویژگی مورد نظر بیشتر از یک مورد نمیتوان اضافه کرد', 'danger')
        return
      }
      if (this.form.type == 'number' && this.form.feature_attributes.length == 1) {
        toast('خطا', 'برای ویژگی "عدد" بیشتر از یک مورد نمیتوان اضافه کرد', 'danger')
        return
      }
      if (this.form.type == 'date' && this.form.feature_attributes.length == 1) {
        toast('خطا', 'برای ویژگی "تاریخ" بیشتر از یک مورد نمیتوان اضافه کرد', 'danger')
        return
      }
      if (this.form.type == 'switch' && this.form.feature_attributes.length == 2) {
        toast('خطا', 'برای ویژگی های "دوحالته" بیشتر از دو مورد نمیتوان اضافه کرد', 'danger')
        return
      }
      if (this.form.type == 'variable' && this.form.feature_attributes.length == 1) {
        toast('خطا', 'برای ویژگی "متغییر" بیشتر از یک مورد نمیتوان اضافه کرد', 'danger')
        return
      }
      if (this.form.type == 'formula' && this.form.feature_attributes.length == 1) {
        toast('خطا', 'برای ویژگی "فرمول" بیشتر از یک مورد نمیتوان اضافه کرد', 'danger')
        return
      }

      this.form.feature_attributes.push({value, filterable: 0, image: [], featureImagePreview: ''})
      this.featureAttributeInput = ''
    },
    removeItem(index) {
      if (this.checkValueIsNumber(this.form.feature_attributes[index] && this.form.feature_attributes[index].id)) {
        this.$store.dispatch('Feature/removeFeatureAttribute', {
          feature_attribute_id: this.form.feature_attributes[index].id,
        })
      }
      this.form.feature_attributes.splice(index, 1)
    },
    submitFeatureAttributeBatching() {
      const lines = (this.formAttributeBatching || '')
          .split(/\n/)
          .map(item => item.trim())
          .filter(Boolean)
      lines.forEach(value => {
        this.form.feature_attributes.push({
          value,
          filterable: this.formAttributeBatchingFilterStatus ? 1 : 0,
          image: [],
          featureImagePreview: '',
        })
      })
      this.formAttributeBatching = ''
      this.showBatch = false
    },
    resetForm() {
      this.form = {
        id: '',
        name: '',
        public_name: '',
        type: 'text',
        language_id: this.form.language_id,
        order: 1,
        feature_attributes: [],
        featureImage: [],
        featureImagePreview: '',
        noRedirect: true,
      }
      this.featureAttributeInput = ''
      this._lastSyncedName = ''
    },
    async loadFeature() {
      if (!this.featureId) {
        return
      }
      this.loading = true
      try {
        const res = await this.$store.dispatch('Feature/getFeature', {id: this.featureId})
        const feature = res.data.data
        this.form.id = feature.id
        this.form.type = feature.type
        this.form.name = feature.name
        this.form.public_name = feature.public_name
        this.form.language_id = feature.language_id
        this.form.order = feature.order
        this.form.featureImagePreview = feature.image
        this.form.feature_attributes = (feature.feature_attributes || []).map(item => ({
          ...item,
          featureImagePreview: item.image,
          image: [],
        }))
      } catch (e) {
        console.log(e)
        toast('خطا', 'بارگذاری ویژگی ناموفق بود.', 'danger')
      } finally {
        this.loading = false
      }
    },
    async onSubmit() {
      if (!this.form.name || !this.form.public_name || !this.form.language_id) {
        toast('خطا', 'نام، نام عمومی و زبان الزامی است.')
        return
      }
      if (!this.form.feature_attributes.length) {
        toast('خطا', 'حداقل یک خصوصیت برای ویژگی اضافه کنید.')
        return
      }
      this.loading = true
      try {
        const payload = {...this.form, noRedirect: true}
        if (this.isEdit) {
          await this.$store.dispatch('Feature/updateFeature', payload)
          toast('عملیات با موفقیت انجام شد', 'ویژگی بروزرسانی شد.')
        } else {
          await this.$store.dispatch('Feature/createFeature', payload)
          toast('عملیات با موفقیت انجام شد', 'ویژگی با موفقیت ثبت شد.')
          this.resetForm()
        }
        await this.$store.dispatch('Feature/getFeatures')
        this.$emit('created')
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    const defaultLanguage = findAttributeOnSiteInfo('default_language')
    if (defaultLanguage && defaultLanguage[0] && !this.form.language_id) {
      this.form.language_id = defaultLanguage[0].id
    }
    if (this.isEdit) {
      this.loadFeature()
    }
  },
  watch: {
    featureId() {
      if (this.isEdit) {
        this.loadFeature()
      }
    },
    mode(value) {
      if (value === 'edit') {
        this.loadFeature()
      } else {
        this.resetForm()
      }
    }
  }
}
</script>

<style scoped>
.quick-feature {
  display: grid;
  gap: 1rem;
}

.quick-feature__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
}

.quick-feature__field label,
.quick-feature__attrs-head label {
  display: block;
  margin-bottom: 0.4rem;
  font-weight: 700;
  color: #424242;
}

.quick-feature__field .form-control,
.quick-feature__field .custom-select,
.quick-feature__add-row .form-control,
.quick-feature__batch-box .form-control {
  border-radius: 12px;
}

.quick-feature__attrs {
  display: grid;
  gap: 0.75rem;
  padding: 0.9rem;
  border-radius: 14px;
  border: 1px solid rgba(30, 30, 30, 0.08);
  background: #f7f7f8;
}

.quick-feature__attrs-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.quick-feature__batch,
.quick-feature__batch-submit,
.quick-feature__add-btn {
  border: 0;
  border-radius: 999px;
  background: #424242;
  color: #fff;
  font-weight: 700;
  padding: 0.45rem 0.9rem;
  cursor: pointer;
}

.quick-feature__batch-box {
  display: grid;
  gap: 0.55rem;
}

.quick-feature__switch {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  font-weight: 600;
}

.quick-feature__add-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.55rem;
}

.quick-feature__items {
  display: grid;
  gap: 0.55rem;
}

.quick-feature__item {
  padding: 0.7rem;
  border-radius: 14px;
  background: #fff;
  border: 1px solid rgba(30, 30, 30, 0.06);
  box-shadow: 0 4px 12px rgba(30, 30, 30, 0.03);
}

.quick-feature__hint {
  margin: 0;
  color: #6b6b6b;
  font-size: 0.85rem;
}

.quick-feature__actions {
  display: flex;
  justify-content: flex-end;
}

.quick-feature__submit {
  min-height: 44px;
  padding: 0 1.4rem;
  border: 0;
  border-radius: 999px;
  background: var(--primary, #eb3d60);
  color: #fff;
  font-weight: 800;
  cursor: pointer;
}

.quick-feature__submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 767.98px) {
  .quick-feature__grid,
  .quick-feature__add-row {
    grid-template-columns: 1fr;
  }
}
</style>
